// frontend/src/pages/admin/cre/api/creClient.js
import axios from 'axios';
import { supabase } from '../../../../lib/supabaseClient';

const api = axios.create({ baseURL: '/api/cre' });

api.interceptors.request.use(async (config) => {
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.access_token) config.headers.Authorization = `Bearer ${session.access_token}`;
  return config;
});

export const creClient = {
  listProposals: (status = 'pending') =>
    api.get('/proposals', { params: { status } }).then((r) => r.data.data),
  listDeliberations: (status) =>
    api.get('/deliberations', { params: { status } }).then((r) => r.data.data),
  approve: (id) => api.post(`/proposals/${id}/approve`).then((r) => r.data),
  reject: (id) => api.post(`/proposals/${id}/reject`).then((r) => r.data),
  runNow: () => api.post('/run').then((r) => r.data),
};
